<!-- Navbar -->
<nav class="navbar fixed-top navbar-expand-lg navbar-light white scrolling-navbar">
  <div class="container">
    <!-- Brand -->
    <a class="navbar-brand waves-effect" href="https://www.vistek.ca/" target="_blank">
      <img src="https://www.vistek.ca/content/images/vistek-logo.png" height="30" alt="Vistek logo" />
    </a>
    <!-- Collapse -->
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Links -->
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <!-- Right -->
      <ul class="navbar-nav nav-flex-icons ml-auto">
        <li class="nav-item pr-3">
          <a href="./cart/login" class="nav-link border border-light rounded waves-effect btn-sm" target="_blank" data-test='continue-shopping'>
            Continue Shopping
          </a>
        </li>
        <li class="nav-item">
          <a
            href="./cart/login"
            class="nav-link border border-primary rounded waves-effect btn-sm btn-rounded"
            target="_blank"
          >
            View Account
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<!-- Navbar -->
<!--Main layout-->
<main class="mt-5 pt-4">
  <div *ngIf="state === ProcessingState.InitialLoading" class="d-flex justify-content-center">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div *ngIf="state === ProcessingState.UserInput && Model === null">Order is not found or already processed.</div>
  <div class="container" *ngIf="Model != null">
    <!--Grid row-->
    <div class="row" style="padding-top: 15px">
      <!--Grid column-->
      <div class="col-lg-8 col-sm-12 col-xs-12 mb-4">
        <div>
          <div class="alert mdkit-alert alert-info bg-muted" *ngIf="Model?.Payments?.DisplayMessage?.Count > 0">
            <b>Changes Needed</b>
            <button type="button" class="close" aria-hidden="true">&times;</button>
            <ul>
              <li *ngFor="let msg of Model.Payments.DisplayMessage">{{ msg }}</li>
            </ul>
          </div>
          <div class="alert mdkit-alert alert-info bg-muted" *ngIf="Model?.Messages?.Count > 0">
            <b>Changes Needed</b>
            <button type="button" class="close" aria-hidden="true">&times;</button>
            <ul>
              <li *ngFor="let msg of Model?.Messages">{{ msg }}</li>
            </ul>
          </div>
        </div>

        <!-- Card -->
        <div class="card">
          <div class="card-body">
            <!-- Address -->
            <h3 class="pb-3">
              <strong>
                <span class="text-primary"> Online </span>
                Payment
              </strong>
            </h3>
            <hr />
            <div>
              <!--Grid row-->
              <div class="row">
                <!--Grid column-->
                <div class="col-md-6 mb-2">
                  <!--firstName-->
                  <h6>
                    <strong>Order: {{ Model?.Order?.SalesOrderID }}</strong>
                  </h6>
                  Date: {{ Model?.Order?.RequestDate | date }}
                </div>
                <!--Grid column-->
                <!--Grid column-->
                <div class="col-md-6 mb-2">
                  <h6>{{ Model?.StoreLocation?.LocationName }}</h6>
                  Call or email for any questions about this order:
                  {{ Model?.StoreLocation?.Phone }} <br />
                  {{ Model?.Order?.SalespersonEmail }}
                </div>
                <!--Grid column-->
              </div>
              <hr />
              <h4 class="pb-3">
                <strong><span class="text-primary">Billing & Shipping </span> Address </strong>
              </h4>
              <div class="row">
                <div class="col-sm-6">
                  <h6>
                    <strong>Billing Address </strong>
                    <!--<a mdbBtn floating="true" size="sm" gradient="blue" data-toggle="modal" data-target="#modalBillingForm" (click)="frame.show()" mdbWavesEffect><mdb-icon far icon="edit"></mdb-icon></a>-->
                  </h6>

                  <div class="table-responsive">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <td><strong>Name:</strong></td>
                          <td>
                            <span id="billingFirst"> {{ Model?.Order?.CustomerName | getname: 1 }} </span>
                            <span id="billingLast"> {{ Model?.Order?.CustomerName | getname: 2 }} </span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Address:</strong></td>
                          <td>
                            <span id="billingAddress1"> {{ Model?.Order?.BillingAddress }} </span>
                            <br *ngIf="Model?.Order?.billingAddress2 != ''" />
                            <span id="billingAddress2"> {{ Model.Order?.BillingAddress2 }} </span>
                            <br />
                            <span id="billingCity"> {{ Model.Order?.BillingCity }} </span>
                            <span id="billingState"> {{ Model.Order?.BillingProv }} </span>
                            <span id="billingCountry"> {{ Model?.Order?.BillingCountry }} </span>,
                            <span id="billingZip"> {{ Model?.Order?.BillingPostalCode }} </span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Company:</strong></td>
                          <td>{{ Model?.Order?.Company }}</td>
                        </tr>
                        <tr>
                          <td><strong>Email:</strong></td>
                          <td>
                            <span id="emailAddress1">{{ Model.Order?.Email }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-sm-6">
                  <h6><strong>Shipping Address</strong></h6>
                  <div class="table-responsive">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <td><strong>Name:</strong></td>
                          <td>
                            <span> {{ Model?.Order?.ShippingName }} </span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Address:</strong></td>
                          <td>
                            <span id="shippingAddress1"> {{ Model.Order?.ShippingAddress }} </span>
                            <br *ngIf="Model?.Order?.ShippingAddress2 != ''" />
                            <span id="shippingAddress2"> {{ Model.Order?.ShippingAddress2 }} </span>
                            <br />
                            <span id="shippingCity"> {{ Model?.Order?.ShippingCity }} </span>
                            <span id="shippingState"> {{ Model.Order?.ShippingProv }} </span>
                            <span id="shippingCountry"> {{ Model?.Order?.ShippingCountry }} </span>,
                            <span id="shippingZip"> {{ Model?.Order?.ShippingPostalCode }} </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!--Grid row-->
              <!--Grid row-->
              <hr />

              <div style="padding-top: 20px">
                <h4 class=" ">
                  <strong><span class="text-primary">Payment</span> Info</strong>
                </h4>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <p class="small">
                    <strong>Please review your order and click submit payment only once.</strong> If you encounter any
                    problems placing your order, please contact us at 1-888-365-1777 to speak directly to one of our
                    helpful Staff or e-mail us at <a href="mailto:sales@vistek.ca">sales@vistek.ca</a> You will recieve
                    an email confirmation of your order and have an order number to use as a reference.
                  </p>
                  <hr />
                </div>

                <div class="col-lg-7 col-sm-12 col-xs-12 border-right">
                  <p class="h5 text-left py-2 text-muted"><strong>Pay By Credit Card</strong></p>

                    <ng-container *ngIf="showAmexNotAllowedErrorMessage">
                        <div class="alert alert-danger" data-testid="amex-payment-blocked">
                            <p class="font-small">
                                We do not accept <strong>American Express</strong>. Please use a different card or method of payment to proceed.
                                <a href="https://www.vistek.ca/about/helpcentre/#wayspayorder" target="_blank" class="info-link">Learn more</a>.
                            </p>
                        </div>
                    </ng-container>

                    <app-credit-card-form (validCardDetected)="onValidCardDetected($event)" data-testid="credit-card-entry-component" #creditCardFormComponent></app-credit-card-form>
                </div>

                <div class="col-lg-5 col-xs-12 col-sm-12">
                  <p class="h5 text-left py-3 text-muted"><strong>Your Order Summary</strong></p>
                  <div class="table-responsive">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <td><strong>Subtotal:</strong></td>
                          <td align="right">
                            <strong>{{ Model?.Order?.SubTotal | currency: "CAD":"symbol":"1.2-2" }}</strong>
                          </td>
                        </tr>
                        <tr *ngIf="Model?.Order?.ShippingCost != null">
                          <td><strong>Shipping:</strong></td>
                          <td align="right">
                            <strong>{{ Model?.Order?.ShippingCost | currency: "CAD":"symbol":"1.2-2" }}</strong>
                          </td>
                        </tr>

                        <tr *ngIf="Model?.Order?.SalesTax != null">
                          <td><strong>Sales Tax</strong></td>
                          <td align="right">
                            <strong>{{ Model?.Order?.SalesTax | currency: "CAD":"symbol":"1.2-2" }}</strong>
                          </td>
                        </tr>

                        <tr *ngIf="Model?.Order?.PSTTax != null">
                          <td><strong>PST</strong></td>
                          <td align="right">
                            <strong>{{ Model?.Order?.PSTTax | currency: "CAD":"symbol":"1.2-2" }}</strong>
                          </td>
                        </tr>

                        <tr>
                          <td><strong>Total</strong></td>
                          <td align="right">
                            <strong>{{ Model?.Order?.GrandTotal | currency: "CAD":"symbol":"1.2-2" }}</strong>
                          </td>
                        </tr>
                        <tr *ngIf="Model?.Order?.BalanceDue != null">
                          <td>
                            <h5><strong>Balance Due</strong></h5>
                          </td>
                          <td align="right">
                            <h5>
                              <strong id="amountPayment">{{
                                Model?.Order?.BalanceDue | currency: "CAD":"symbol":"1.2-2"
                              }}</strong>
                            </h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <button
                    id="startButton"
                    type="submit"
                    *ngIf="Model.Payments.PaymentType == 'CreditCard'"
                    [disabled]="isInProgress()"
                    (click)="completePurchase()"
                    class="btn btn-warning btn-lg btn-block"
                    style="background-color: #f07905"
                    data-testid="complete-purchase"
                  >
                    <ng-container *ngIf="isInProgress(); then processing; else ready"> </ng-container>
                    <ng-template #processing>
                      <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span
                      >Processing...
                    </ng-template>
                    <ng-template #ready> Complete Purchase </ng-template>
                  </button>
                  <hr />
                  <!--Material textarea-->
                  <div class="md-form md-outline">
                    <textarea
                      id="orderDescription"
                      class="md-textarea form-control"
                      [formControl]="instructionsControl"
                      rows="3"
                      data-test-input="order-description"
                    ></textarea>
                    <label for="orderDescription">Special Instructions</label>
                    <input type="hidden" id="byPass3ds" value="{{ Model?.Order?.ByPass3ds }}" />
                  </div>
                  <hr />
                </div>
              </div>
            </div>
            <!--/.Panel 3-->
          </div>
        </div>
        <!-- Heading -->
        <!-- Card -->
      </div>
      <!--Grid column-->
      <!--Grid column-->
      <div class="col-lg-4 col-sm-12 col-xs-12 mb-4">
        <!-- Cart -->
        <div class="card z-depth-1">
          <div class="card-body">
            <h5 class="d-flex justify-content-between align-items-center mb-3">
              <strong><span class="text-muted">Your Cart items</span></strong>
              <span class="grey-text small"></span>
            </h5>
            <hr />

            <table mdbTable responsive="true">
              <tbody>
                <tr *ngFor="let orderItem of Model?.Order?.CartWebPaymentOrderDetails">
                  <!--var content = Model.OrderDetailContent?.FirstOrDefault(x => x.Webcode == orderItem.Number);-->
                  <td>
                    <img
                      [src]="getImage(orderItem?.Number)"
                      media-size="75"
                      alt="{{ orderItem?.ProdName }}"
                      border="0"
                    />
                    <div class="webcode text-center text-small">{{ orderItem?.Number }}</div>
                  </td>
                  <td>
                    {{ orderItem?.Manufacturer }} {{ orderItem?.ProdName }}<br /><small class="text-muted">{{
                      orderItem?.UnitOfMeasure
                    }}</small>
                  </td>

                  <td>
                    {{ orderItem?.UnitPrice | currency: "CAD":"symbol":"1.2-2" }}<br />
                    <small class="text-muted" *ngIf="orderItem?.Quantity != null && orderItem?.Quantity > 0"
                      >QTY {{ orderItem?.Quantity }}</small
                    >
                  </td>
                </tr>
              </tbody>
            </table>

            <hr />
          </div>
        </div>
        <!-- Cart -->
        <div class="content text-muted" style="padding-top: 30px">
          <h6><i class="fa fa-link" aria-hidden="true"></i> <strong> Helpful Links</strong></h6>
          <small class="text-muted">
            <a href="/about/shipping"> Shipping</a> | <a href="/about/returns">Returns</a> |
            <a href="/about/privacy/"> Privacy</a></small
          >
          <hr />

          <h6><i class="fa fa-lock" aria-hidden="true"></i> <strong> Shop Secure at Vistek</strong></h6>
          <small class="text-muted">
            All personal information you provide will be confidential and Transactions on Vistek.ca are secure
          </small>
        </div>
      </div>
      <!--Grid column-->
    </div>
    <!--Grid row-->
  </div>
  <iframe name="ddc-iframe" height="10" width="10" style="display: none"></iframe>
  <form
    id="ddc-form"
    target="ddc-iframe"
    method="POST"
    *ngIf="payerAuthSetupResponse"
    [action]="payerAuthSetupResponse.deviceDataCollectionURL"
    #ddcForm
  >
    <input type="hidden" name="JWT" [value]="payerAuthSetupResponse.accessToken" />
  </form>
  <div
    class="modal fade"
    tabindex="-1"
    aria-modal="true"
    role="dialog"
    mdbModal
    #stepUpModal="mdbModal"
    (closed)="onStepUpClosed()"
  >
    <div class="modal-dialog modal-dialog-centered" style="width: fit-content">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="state = ProcessingState.UserInput">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title w-100">Purchase Authentication</h4>
        </div>
        <div class="modal-body p-0" *ngIf="state === ProcessingState.ChallengeReceived">
          <iframe
            name="step-up-iframe"
            [height]="authorizationResponse.Challenge.windowDimensions.height"
            [width]="authorizationResponse.Challenge.windowDimensions.width"
            class="step-up-iframe"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
  <form
    *ngIf="state === ProcessingState.ChallengeReceived"
    id="step-up-form"
    target="step-up-iframe"
    method="post"
    [action]="authorizationResponse.Challenge.StepUpUrl"
    #stepUpForm
  >
    <input type="hidden" name="JWT" [value]="authorizationResponse.Challenge.AccessToken" />
    <input type="hidden" name="MD" [value]="origin" />
  </form>
  <form
    [action]="authResultUrl"
    #authResultForm
    method="POST"
    style="display: none"
    *ngIf="state === ProcessingState.AuthorizationReceived"
  >
    <input type="hidden" [value]="Model.Order.SalesOrderID" name="salesOrderID" />
    <input type="hidden" [value]="authorizationResponse.Transaction.PaymentComments" name="messageTxt" />
    <input type="hidden" [value]="authorizationResponse.ReasonCode" name="reasonCode" />
    <input type="hidden" [value]="authorizationResponse.Transaction.TransactionRef" name="transactionRef" />
    <input type="hidden" [value]="authorizationResponse.CardholderMessage" name="cardholderMessage" />
  </form>
</main>
<!--Main layout-->
<!--Footer-->
<footer class="page-footer special-color-dark text-center font-small mt-4">
  <hr class="my-4" />
  <!--Copyright-->
  <div class="footer-copyright py-3">
    © 2021 Copyright:
    <a href="https://www.vistek.ca" target="_blank"> Vistek Ltd. </a>
  </div>
  <!--/.Copyright-->
</footer>
